import { unFormatCurrency } from '@/common/utils/unFormatters'
import { z } from 'zod'

export const createSupplyAuthorizationSchema = z.object({
  government_allocation_id: z.string({ message: 'Campo obrigatório' }).min(1, 'Campo obrigatório'),
  allocation_accounting_number: z.string({ message: 'Campo obrigatório' }).min(1, 'Campo obrigatório'),
  amount: z.string({ message: 'Campo obrigatório' }).refine(unFormatCurrency, { message: 'Campo obrigatório' }),
  file: z
    .custom<File | string>()
    .optional()
    .refine((file) => !!file && typeof file !== 'string', {
      message: 'Campo Anexo é obrigatório',
    }),
  file_name: z.string().optional(),
})

export type CreateSupplyAuthorizationValidationSchema = z.infer<typeof createSupplyAuthorizationSchema>
